module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-lines-6-98fa0cd146efa8af51a4e57ac860108a.svg";